export default __webpack_public_path__ + "static/media/certification3.76aef667.jpg";